module.exports = __webpack_public_path__ + "img/growcify-default-banner.02641290.png";